export default class DataManager {
    constructor(_option={}){
        this.option = _option;
        this.data = {
            moviePlayer: {},
            live: {},
            popular: {}
        };
        this.callList = {};
        this.aliasList = [];
        this.aliasKeyList = [];
        this.apiDomain = this.option.apiDomain;
        this.apiBoardDomain = this.option.apiBoardDomain;
    }

    init(){}

    addCall(_key='', _data={}){
        this.callList[_key] = _data;
    }

    addManual(_aliasKey, _alias){
        this.aliasKeyList.push(_aliasKey);
        this.aliasList.push(_alias);
    }

    loadFullData(){
        return new Promise((resolve, reject) => {
            $.ajax ( {
                type: "POST",
                url: this.apiDomain + "/v1/batch",
                data: JSON.stringify(this.callList),
                contentType: "application/json"
            })
            .fail( xhr => reject(xhr) )
            .done( ( _d )=>{
                for (var key in _d) {
                    if (_d.hasOwnProperty(key)) {
                        let datas = _d[key];
                        if( datas.body.result === 'SUCCESS' ){
                            this.data[key] = datas.body.data.content;
                        } else {
                            this.data[key] = datas.body.result;
                        }
                    }
                }
                resolve(_d);
            });
        });
    }

    loadManualData(){
        return new Promise((resolve, reject) => {
            if(!this.aliasList.length){
                resolve();
                return false;
            }

            $.ajax ( {
                type: "GET",
                url: "/conti/getContent?service=nctv&lang=ko-KR&alias=" + this.aliasList.join(),
                dataType: "json",
                contentType: "application/json",
                Accept: "application/json"
            })
            .fail( xhr => reject(xhr) )
            .done( ( _d )=>{
                if($.isArray( JSON.parse(_d.jsonData) )){
                    $.each(this.aliasKeyList, (idx, key)=>{
                        let datas = _d[idx];
                        if(key==='moviePlayer'){
                            this.data[key] = datas.list;
                        }
                        if(key==='topBanner'){
                            this.data[key] = datas;
                        }
                    });
                }else{
                    this.data.moviePlayer = (JSON.parse(_d.jsonData)).list;
                }

                resolve(_d);
            });
        });
    }

    loadNoticeData(){
        return new Promise((resolve, reject) => {
            $.ajax ( {
                type: "GET", contentType: "application/json",
                url: this.apiBoardDomain+ `/board/notice/article.json?page=1&isReferer=false&size=1`
            })
            .fail( xhr => reject(xhr) )
            .done( ( _d )=>{
                this.data.notice = _d.articleList && _d.articleList[0];
                resolve(_d);
            });
        });
    }
    
} // end of class